
export default {
	name: 'use-change-result',
	mixins: [],
	extends: {},
	components: {},
	props: [],
	data() {
		return {};
	},
	computed: {

	},
	watch: {},
	created() {},
	mounted() {},
	updated() {},
	beforeDestroy() {},
	methods: {},
};



// WEBPACK FOOTER //
// ./src/components/basicSetting/useChange/useChangeResult.js